import React from "react";
import { StldCardOptions } from "../../styled-components/StyledCardOptions.style";
import { StyledCircleItem } from "../../styled-components/StyledCircleItem.style";
import { IconMenuDotsV } from "../../svg";

export const CardPericiaOptions = (props) => {
    const { id, status, title, subtitle, info, type } = props;

    return (
        <StldCardOptions>
            <div className="d-flex">
                <div className="info-sections">
                    <div className="d-flex mb-1">
                        <p className="mini-info font-weight-bold my-0 mr-1">
                            {id}
                        </p>
                        <div className="mini-info d-flex align-items-center font-weight-normal my-0">
                            <StyledCircleItem
                                size="10px"
                                borderColor="#32A814"
                                backgroundColor="#32A814"
                            />
                            {!!status ? status : "Cancelado"} horas
                        </div>
                    </div>
                    <div className="mb-2">
                        <h2 className="info font-weight-bold mb-2">{title}</h2>
                        <h2 className="info font-weight-normal mb-2">
                            {subtitle}
                        </h2>
                        <p className="mini-info font-weight-normal">{info}</p>
                    </div>
                    <div>
                        <p className="mini-info font-weight-normal">{type}</p>
                    </div>
                </div>
                <div className="menu-sections cursor-pointer">
                    <IconMenuDotsV />
                </div>
            </div>
        </StldCardOptions>
    );
};
